import React from "react";

import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Paper,
  Stack,
  Divider,
} from "@mui/material";

import {
  CalendarMonthOutlined,
  DescriptionOutlined,
  CheckCircleOutlined,
  AccessTimeOutlined,
  WhatsApp,
  ArrowForward,
  SchoolOutlined,
  FavoriteBorderOutlined,
  GroupsOutlined,
  TrendingUpOutlined,
  SecurityOutlined,
} from "@mui/icons-material";

import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";

import matricula from "../../assets/Doc/Ficha-Matricula.doc";
import salud from"../../assets/Doc/Ficha-de-salud.docx";
import permiso from "../../assets/Doc/AUTORIZACION-USO-DE-IMAGEN-y-electividad-de-Religion.docx";

import Admi from "../../assets/img/admision.png";

export const AdmisionPages = () => {
    const documentos = [
  {
    nombre: "Ficha de salud",
    archivo: salud,
    descarga: true,
  },
  {
    nombre: "Ficha de matrícula",
    archivo: matricula,
    descarga: true,
  },
  {
    nombre:
      "Autorización para el uso de imagen, video y audio y adhesión a clases de religión",
    archivo: permiso,
    descarga: true,
  },
  {
    nombre: "Certificado de nacimiento del alumno actualizado",
    url: "https://www.registrocivil.cl/principal/servicios-en-linea",
    externo: true,
  },
  {
    nombre:
      "Fotocopia de la cédula de identidad del apoderado financiero",
  },
];
  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",
        overflow: "hidden",
      }}
    >
      {/* =====================================================
          HERO
      ====================================================== */}

      <Box
        sx={{
          position: "relative",

        }}
      >


       
<Container
  maxWidth="xl"
  sx={{
    position: "relative",
    zIndex: 2,
  }}
>
  <Grid
    container
    spacing={{
      xs: 5,
      md: 8,
    }}
    alignItems="center"
  >

   

    <Grid
      size={{
        xs: 12,
        md: 6,
      }}
      sx={{
        order: {
          xs: 2,
          md: 1,
        },
      }}
    >
      <Box
        sx={{
          maxWidth: "550px",

          // En desktop empuja el contenido hacia la derecha
          ml: {
            xs: 0,
            md: "auto",
          },

          pr: {
            xs: 0,
            md: 3,
          },

          pt: {
            xs: 0,
            md: 5,
          },
        }}
      >
        <Typography
          sx={{
            color: "#8f1515",
            fontWeight: 700,
            fontSize: {
              xs: "0.85rem",
              md: "1rem",
            },
            letterSpacing: "1.5px",
            mb: 1,
          }}
        >
          BIENVENIDOS A NUESTRO COLEGIO
        </Typography>

        <Typography
          component="h1"
          sx={{
            fontWeight: 800,
            color: "#252525",
            fontSize: {
              xs: "2rem",
              sm: "3rem",
              md: "5rem",
            },
            lineHeight: 0.95,
            mb: 1,
          }}
        >
          ADMISIÓN
        </Typography>

        <Typography
          component="span"
          sx={{
            display: "block",
            fontWeight: 800,
            color: "#8f1515",
            fontSize: {
              xs: "2rem",
              sm: "3rem",
              md: "5rem",
            },
            lineHeight: 0.95,
          }}
        >
          2026
        </Typography>

        <Box
          sx={{
            width: 65,
            height: 4,
            backgroundColor: "#8f1515",
            my: 3,
            borderRadius: 5,
          }}
        />

        <Typography
          sx={{
            color: "#555",
            fontSize: {
              xs: "1rem",
              md: "1.15rem",
            },
            lineHeight: 1.7,
            maxWidth: "480px",
          }}
        >
          Formamos personas íntegras, con valores sólidos y
          excelencia académica para construir un mejor futuro.
        </Typography>

        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={2}
          sx={{
            mt: 4,
          }}
        >
          
          <Button
          href="/quienes-somos"
            variant="outlined"
            endIcon={<ArrowForward />}
            sx={{
              color: "#8f1515",
              borderColor: "#8f1515",
              borderRadius: "12px",
              px: 3,
              py: 1.5,
              fontWeight: 700,

              "&:hover": {
                borderColor: "#561c33",
                color: "#561c33",
                backgroundColor: "rgba(143,21,21,0.04)",
              },
            }}
          >
            CONOCE NUESTRO COLEGIO
          </Button>
        </Stack>
      </Box>
    </Grid>


  

    <Grid
      size={{
        xs: 12,
        md: 6,
      }}
      sx={{
        order: {
          xs: 1,
          md: 2,
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={Admi}
          alt="Admisión Colegio"
          sx={{
            width: "100%",
            height: "auto",
            objectFit: "cover",
            display: "block",
            position: "relative",
            zIndex: 2,
          }}
        />

        {/* TARJETA FECHA */}

        <Paper
          elevation={8}
          sx={{
            position: "absolute",

            right: {
              xs: 150,
              sm: 10,
              md: 60,
            },

            bottom: {
              xs: 10,
              sm: 20,
              md: 35,
            },

            zIndex: 4,

            borderRadius: "18px",

            p: {
              xs: 1.5,
              sm: 2,
              md: 3,
            },

            minWidth: {
              xs: "180px",
              sm: "210px",
              md: "260px",
            },

            backgroundColor: "#ffffff",
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
          >
            <Box
              sx={{
                width: {
                  xs: 45,
                  md: 55,
                },
                height: {
                  xs: 45,
                  md: 55,
                },
                flexShrink: 0,
                borderRadius: "50%",
                backgroundColor: "#8f1515",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
              }}
            >
              <CalendarMonthOutlined />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: {
                    xs: "0.65rem",
                    md: "0.75rem",
                  },
                  fontWeight: 700,
                  color: "#555",
                }}
              >
                PERÍODO DE
              </Typography>

              <Typography
                sx={{
                  fontWeight: 800,
                  color: "#252525",
                  fontSize: {
                    xs: "0.9rem",
                    md: "1rem",
                  },
                }}
              >
                MATRÍCULAS
              </Typography>

              <Typography
                sx={{
                  color: "#8f1515",
                  fontWeight: 800,
                  fontSize: {
                    xs: "1rem",
                    md: "1.2rem",
                  },
                }}
              >
                09 al 23
              </Typography>

              <Typography
                sx={{
                  fontSize: {
                    xs: "0.65rem",
                    md: "0.75rem",
                  },
                  fontWeight: 600,
                }}
              >
                DICIEMBRE 2026
              </Typography>
            </Box>
          </Stack>
        </Paper>
      </Box>
    </Grid>

  </Grid>
</Container>
      </Box>

      {/* =====================================================
          POR QUÉ ELEGIRNOS
      ====================================================== */}

      <Box
        sx={{
          py: {
            xs: 7,
            md: 10,
          },
          backgroundColor: "#ffffff",
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              textAlign: "center",
              mb: 6,
            }}
          >
            <Typography
              sx={{
                color: "#8f1515",
                fontWeight: 700,
                fontSize: "0.9rem",
                letterSpacing: "1px",
              }}
            >
              ¿POR QUÉ ELEGIRNOS?
            </Typography>

            <Typography
              component="h2"
              sx={{
                mt: 1,
                fontWeight: 800,
                fontSize: {
                  xs: "2rem",
                  md: "2.8rem",
                },
                color: "#252525",
              }}
            >
              Educamos con{" "}
              <Box
                component="span"
                sx={{
                  color: "#8f1515",
                }}
              >
                amor y excelencia
              </Box>
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {[
              {
                icon: <SchoolOutlined />,
                title: "Educación de calidad",
                text: "Programas académicos actualizados y centrados en el desarrollo integral.",
              },
              {
                icon: <FavoriteBorderOutlined />,
                title: "Formación en valores",
                text: "Promovemos el respeto, la responsabilidad y la solidaridad.",
              },
              {
                icon: <GroupsOutlined />,
                title: "Equipo comprometido",
                text: "Docentes y profesionales dedicados al crecimiento de cada estudiante.",
              },
              {
                icon: <SecurityOutlined />,
                title: "Ambiente seguro",
                text: "Espacios seguros y acogedores que fomentan el bienestar y la confianza.",
              },
              {
                icon: <TrendingUpOutlined />,
                title: "Proyección de futuro",
                text: "Preparamos a nuestros estudiantes para los desafíos del mañana.",
              },
            ].map((item, index) => (
              <Grid size={{xs:12,sm:6,md:2.4}}  key={index}>
                <Paper
                  elevation={0}
                  sx={{
                    height: "100%",
                    p: 3,
                    textAlign: "center",
                    borderRadius: "20px",
                    border: "1px solid #eeeeee",
                    transition: "all 0.3s ease",

                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow:
                        "0 15px 35px rgba(0,0,0,0.10)",
                      borderColor: "#8f1515",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 65,
                      height: 65,
                      mx: "auto",
                      mb: 2,
                      borderRadius: "50%",
                      backgroundColor: "#8f1515",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {item.icon}
                  </Box>

                  <Typography
                    sx={{
                      fontWeight: 800,
                      fontSize: "0.95rem",
                      color: "#252525",
                      mb: 2,
                    }}
                  >
                    {item.title}
                  </Typography>

                  <Divider
                    sx={{
                      width: 35,
                      mx: "auto",
                      mb: 2,
                      borderColor: "#8f1515",
                      borderBottomWidth: 3,
                    }}
                  />

                  <Typography
                    sx={{
                      color: "#666",
                      fontSize: "0.85rem",
                      lineHeight: 1.6,
                    }}
                  >
                    {item.text}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>



      <Box
        sx={{
          py: {
            xs: 7,
            md: 10,
          },
          backgroundColor: "#fafafa",
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              textAlign: "center",
              mb: 6,
            }}
          >
            <Typography
              sx={{
                color: "#8f1515",
                fontWeight: 700,
              }}
            >
              INFORMACIÓN DE ADMISIONES
            </Typography>

            <Typography
              component="h2"
              sx={{
                fontWeight: 800,
                fontSize: {
                  xs: "2rem",
                  md: "2.7rem",
                },
              }}
            >
              Todo lo que necesitas saber
            </Typography>
          </Box>

          <Grid container spacing={4}>
       

            <Grid size={{ xs:12, sm:6, md:5}}>
              <Paper
                sx={{
                  height: "100%",
                  p: {
                    xs: 3,
                    md: 4,
                  },
                  borderRadius: "25px",
                  background:
                    "linear-gradient(135deg, #8f1515, #561c33)",
                  color: "#ffffff",
                }}
              >
                <Stack
                  direction="row"
                  spacing={2}
             
                  sx={{
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center',
                    mb:3
                  }}
                  
                >
                  <Box
                    sx={{
                      width: 55,
                      height: 55,
                      borderRadius: "15px",
                      backgroundColor: "#ffffff",
                      color: "#8f1515",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CalendarMonthOutlined />
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                    }}
                  >
                    Fechas de atención
                  </Typography>
                </Stack>

                <Stack spacing={3}>
                  <Box>
                    <Typography fontWeight={700} 
                    sx={{
                        display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}>
                     
                    <CalendarMonthOutlined  sx={{
                          fontSize: 17,
                          verticalAlign: "middle",
                          mr: 1,
                        }}/>
                   09 al 23 de diciembre 2026
                    </Typography>
                  </Box>

                  <Divider
                    sx={{
                      borderColor:
                        "rgba(255,255,255,0.25)",
                    }}
                  />

                  <Box>
                    <Typography
                      fontWeight={700}
                      mb={1}
                    >
                      Lunes a Jueves
                    </Typography>

                    <Typography
                      sx={{
                        opacity: 0.9,
                      }}
                    >
                      <AccessTimeOutlined
                        sx={{
                          fontSize: 17,
                          verticalAlign: "middle",
                          mr: 1,
                        }}
                      />
                      Mañana: 08:30 a 13:30 hrs.
                    </Typography>

                    <Typography
                      sx={{
                        opacity: 0.9,
                        mt: 1,
                      }}
                    >
                      <AccessTimeOutlined
                        sx={{
                          fontSize: 17,
                          verticalAlign: "middle",
                          mr: 1,
                        }}
                      />
                      Tarde: 14:30 a 16:30 hrs.
                    </Typography>
                  </Box>

                  <Divider
                    sx={{
                      borderColor:
                        "rgba(255,255,255,0.25)",
                    }}
                  />

                  <Box>
                    <Typography
                      fontWeight={700}
                      mb={1}
                    >
                      Viernes
                    </Typography>

                    <Typography
                      sx={{
                        opacity: 0.9,
                      }}
                    >
                      <AccessTimeOutlined
                        sx={{
                          fontSize: 17,
                          verticalAlign: "middle",
                          mr: 1,
                        }}
                      />
                      Mañana: 08:30 a 14:30 hrs.
                    </Typography>
                  </Box>
                </Stack>
              </Paper>
            </Grid>

            {/* DOCUMENTOS */}

            <Grid size={{ xs:12,sm:6, md:7}}>
              <Paper
                elevation={0}
                sx={{
                  height: "100%",
                  p: {
                    xs: 3,
                    md: 4,
                  },
                  borderRadius: "25px",
                  backgroundColor: "#ffffff",
                  border: "1px solid #eeeeee",
                }}
              >
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                  mb={3}
                >
                  <Box
                    sx={{
                      width: 55,
                      height: 55,
                      borderRadius: "15px",
                      backgroundColor: "#f7eaea",
                      color: "#8f1515",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <DescriptionOutlined />
                  </Box>

                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 800,
                    }}
                  >
                    Documentos requeridos
                  </Typography>
                </Stack>

               <Stack spacing={0}>
  {documentos.map((documento, index) => (
    <Box key={index}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        sx={{
          py: 1.8,
        }}
      >
        {/* DOCUMENTO */}

        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{
            flex: 1,
            minWidth: 0,
          }}
        >
          <CheckCircleOutlined
            sx={{
              color: "#8f1515",
              fontSize: 22,
              flexShrink: 0,
            }}
          />

          <Typography
            sx={{
              color: "#444",
              fontSize: "0.95rem",
              lineHeight: 1.5,
            }}
          >
            {documento.nombre}
          </Typography>
        </Stack>

        {/* BOTÓN DESCARGAR */}

        {documento.descarga && documento.archivo && (
          <Button
            component="a"
            href={documento.archivo}
            download
            variant="outlined"
            startIcon={<DownloadOutlinedIcon />}
            sx={{
              flexShrink: 0,

              color: "#8f1515",
              borderColor: "#8f1515",

              borderRadius: "10px",

              px: {
                xs: 1.5,
                sm: 2,
              },

              py: 0.8,

              fontSize: {
                xs: "0.7rem",
                sm: "0.8rem",
              },

              fontWeight: 700,

              minWidth: {
                xs: "auto",
                sm: "120px",
              },

              "&:hover": {
                backgroundColor: "#8f1515",
                borderColor: "#8f1515",
                color: "#ffffff",
              },
            }}
          >
            <Box
              component="span"
              sx={{
                display: {
                  xs: "none",
                  sm: "inline",
                },
              }}
            >
              DESCARGAR
            </Box>
          </Button>
        )}

        {/* BOTÓN REGISTRO CIVIL */}

        {documento.externo && documento.url && (
          <Button
            component="a"
            href={documento.url}
            target="_blank"
            rel="noopener noreferrer"
            variant="outlined"
            startIcon={<OpenInNewOutlinedIcon />}
            sx={{
              flexShrink: 0,

              color: "#8f1515",
              borderColor: "#8f1515",

              borderRadius: "10px",

              px: {
                xs: 1.5,
                sm: 2,
              },

              py: 0.8,

              fontSize: {
                xs: "0.7rem",
                sm: "0.8rem",
              },

              fontWeight: 700,

              minWidth: {
                xs: "auto",
                sm: "120px",
              },

              "&:hover": {
                backgroundColor: "#8f1515",
                borderColor: "#8f1515",
                color: "#ffffff",
              },
            }}
          >
            <Box
              component="span"
              sx={{
                display: {
                  xs: "none",
                  sm: "inline",
                },
              }}
            >
              IR AL REGISTRO
            </Box>
          </Button>
        )}
      </Stack>

      {index < documentos.length - 1 && (
        <Divider />
      )}
    </Box>
  ))}
</Stack>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* =====================================================
          CTA
      ====================================================== */}

      <Container
        maxWidth="lg"
        sx={{
          py: {
            xs: 6,
            md: 8,
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            overflow: "hidden",
            borderRadius: "28px",
            background:
              "linear-gradient(135deg, #8f1515, #561c33)",
            p: {
              xs: 4,
              md: 6,
            },
            color: "#ffffff",
          }}
        >
          {/* decoración */}

          <Box
            sx={{
              position: "absolute",
              width: 300,
              height: 300,
              borderRadius: "50%",
              backgroundColor:
                "rgba(255,255,255,0.05)",
              right: -100,
              top: -120,
            }}
          />

          <Grid
            container
            spacing={3}
            alignItems="center"
            position="relative"
          >
            <Grid size={12}>
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: {
                    xs: "1.8rem",
                    md: "1.3rem",
                  },
                  mb: 1,
                }}
              >
                ¡Sé parte de nuestra comunidad educativa!
              </Typography>

              <Typography
                sx={{
                  opacity: 0.9,
                  fontSize: "1rem",
                  maxWidth: 600,
                }}
              >
                Postula a tu hijo o hija y juntos construyamos
                un camino lleno de aprendizaje, valores y
                oportunidades.
              </Typography>
            </Grid>

          
          </Grid>
        </Box>
      </Container>

      {/* =====================================================
          WHATSAPP
      ====================================================== */}

      <Box
        sx={{
          pb: {
            xs: 7,
            md: 10,
          },
        }}
      >
        <Container maxWidth="md">
          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: "#8f1515",
                fontWeight: 700,
                mb: 1,
              }}
            >
              ¿TIENES DUDAS?
            </Typography>

            <Typography
              variant="h4"
              sx={{
                fontWeight: 800,
                mb: 2,
              }}
            >
              Estamos para ayudarte
            </Typography>

            <Typography
              sx={{
                color: "#666",
                mb: 3,
              }}
            >
              Contáctanos por WhatsApp y nuestro equipo te
              orientará durante todo el proceso de admisión.
            </Typography>

            <Button
  component="a"
  href="https://wa.me/56932385589"
  target="_blank"
  rel="noopener noreferrer"
  variant="contained"
  startIcon={<WhatsApp />}
  sx={{
    backgroundColor: "#25D366",
    borderRadius: "14px",
    px: 4,
    py: 1.6,
    fontWeight: 700,

    "&:hover": {
      backgroundColor: "#1da851",
    },
  }}
>
  CONTÁCTANOS POR WHATSAPP
</Button>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};